var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCake(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m57.5367,18.0513l-16.5406,2.5102-2.0738.4311-31.9223,5.0074c-1.1045,0-2,.8965-2,2v12h1c2.7617,0,5-2.2383,5-4.999s2.2383-5.001,5-5.001,5,2.2393,5,5.001,2.2383,4.999,5,4.999,5-2.2383,5-4.999,2.2383-5.001,5-5.001,5,2.2393,5,5.001,2.2383,4.999,5,4.999,5-2.2383,5-4.999,2.2383-5.001,5-5.001,5,2.2393,5,5.001,2.2383,4.999,5,4.999h1v-12c0-4.7112-3.2599-8.6632-7.647-9.7215-.4344-.1048-1.3618-.1812-1.8163-.2272"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 18.0005,
    r: 5,
    fill: "#ea5a47"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcea2b",
    d: "m67,39v20c0,1.1055-.8955,2-2,2H7c-1.1045,0-2-.8945-2-2v-20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcea2b",
    d: "m67,40h-1c-2.7607,0-5-2.2383-5-5s-2.2393-5-5-5-5,2.2383-5,5-2.2393,5-5,5-5-2.2383-5-5-2.2393-5-5-5-5,2.2383-5,5-2.2393,5-5,5-5-2.2383-5-5-2.2393-5-5-5-5,2.2383-5,5-2.2393,5-5,5h-1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m67,28v31c0,1.1055-.8955,2-2,2H7c-1.1045,0-2-.8945-2-2v-31c0-1.1035.8955-2,2-2l33.9961-5.4385"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m58.0186,18.0513c5.0439.5102,8.9814,4.771,8.9814,9.9487"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m5,40h1c2.7617,0,5-2.2383,5-4.999s2.2383-5.001,5-5.001,5,2.2393,5,5.001,2.2383,4.999,5,4.999,5-2.2383,5-4.999,2.2383-5.001,5-5.001,5,2.2393,5,5.001,2.2383,4.999,5,4.999,5-2.2383,5-4.999,2.2383-5.001,5-5.001,5,2.2393,5,5.001,2.2383,4.999,5,4.999h1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    x2: 67,
    y1: 48,
    y2: 48,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    x2: 67,
    y1: 52,
    y2: 52,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 18.0005,
    r: 5,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m49.5,16c0-5.5229,4.4766-10,10-10"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/cake.ab59aeef091732300ccaf0e6db9ae9f7.svg";
export { ForwardRef as ReactComponent };